import type { LinkModuleSection } from './link-module'
import type { ContentLinkBlock } from '@/gen/types'

export function mapFromGQLContentLinkBlockToLinkSectionProps(
  contentLinkBlock: ContentLinkBlock | null | undefined,
): LinkModuleSection | null {
  if (!contentLinkBlock) {
    return null
  }

  return {
    title: contentLinkBlock.title,
    links:
      contentLinkBlock?.links?.map(link => {
        if (link.url.includes('http')) {
          //this means that the link is coming from WP and the link is absolute
          const url = new URL(link.url)

          return { label: link.anchor, href: url.pathname }
        }

        return { label: link.anchor, href: link.url }
      }) || [],
  }
}
